<template>

  <div class="dropdown" v-click-outside="onClose">
    <div 
      class="dropbtn"
      :class="{ dropbtnOpen: open,
                dropbtnClosed: !open,
                disabled: options.length == 0 }"
      @click="toggleOpen">
      <div v-if="modelValue">{{ modelValue[labelby] }}</div>
      <div v-else-if="placeholder != ''">{{ placeholder }}</div>
      <div v-else/>
      <font-awesome-icon v-if="!open" icon="caret-down"></font-awesome-icon>
      <font-awesome-icon v-else icon="caret-up"></font-awesome-icon>
    </div>
    <div v-if="open"
      id="myDropdown"
      class="dropdown-content">
      <div v-if="searchable"
        class="dropdown-search">
        <input type="text"
          v-model="searchtext"
          ref="searchInput"
          tabindex="-1"
          :placeholder="searchplaceholder"/>
      </div>
      <div class="dropdown-options">
        <span v-for="option,index in filteredOptions"
          :key="index"
          @click="selectOption( option)"
          :class="[ option == modelValue ? 'optionSelected' : 'optionNormal' ]"
        >{{ option[labelby] }}</span>
      </div>
    </div>
  </div>

</template>

<script>
import vClickOutside from 'click-outside-vue3'

export default {
  name: 'Dropdown',
  components: {
  },
  data: function () {
    return {
      open: false,
      searchtext: '',
    }
  },
  props: {
    modelValue: {
      type: Object,
      required: false, // if set to true, it will complain about passing initial null
    },
    options: {
      type: Array,
      required: true,
    },
    labelby: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    searchable: {
      type: Boolean,
      default: false,
    },
    searchplaceholder: {
      type: String,
      default: '',
    }
  },
  emits: [
    'update:modelValue',
  ],
  directives: {
    ClickOutside: vClickOutside.directive,
  },
  computed: {
    filteredOptions() {
      if( !this.searchtext ) return this.options
      return this.options.filter( o => o[this.labelby].toLowerCase().indexOf( this.searchtext.toLowerCase() ) != -1 )
    },
  },
  methods: {
    toggleOpen() {
      if( this.open ) this.open = false
      if( !this.open && this.options.length > 0 ) {
        this.open = true

        // Focus input-component for searching
        if( this.searchable ) {
          this.$nextTick(() => {
            this.$refs['searchInput'].focus()
          });          
        }
      }
    },
    onClose() {
      this.open = false
    },
    selectOption( option ) {
      let result = null
      if( this.modelValue != option ) result = option

      this.$emit( 'update:modelValue', result )

      this.open = false
    },
  },
}
</script>

<style scoped>
/* Dropdown Button */
.dropbtn {
  background-color: transparent;
  border: 1px solid #999;
  font-size: 13px;
  padding: 3px 4px;
  display: flex;
  justify-content: space-between; 
  gap: 5px;
}
.dropbtnOpen {
  border-radius: 4px 4px 0 0;
}
.dropbtnClosed {
  border-radius: 4px;
}
.disabled {
  color: rgb(62, 65, 68);
  border-color: rgb(62, 65, 68);
}

/* Dropdown button on hover & focus */
.dropbtn:hover, .dropbtn:focus {
  background-color: rgb( 71, 75, 83);
}
.disabled:hover {
  background-color: transparent;
}


/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  position: absolute;
  background-color: var(--main-bg-color);
  width: calc( 100% - 2px);
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  border-top: 0px;
  border-left: 1px;
  border-right: 1px;
  border-bottom: 1px;
  border-style: solid;
  border-color: #999;
  border-radius: 0 0 4px 4px;
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

.dropdown-options {
  display: flex;
  flex-direction: column;
  max-height: 300px;
  overflow-x: hidden;
  overflow-y: auto;
}

/* Links inside the dropdown */
.dropdown-options span {
  padding: 4px;
}

/* search box */
.dropdown-search {
  border-top: 0px;
  border-left: 0px;
  border-right: 0px;
  border-bottom: 1px;
  border-style: solid;
  border-color: #999;
  padding: 4px 4px 3px 4px;
}
.dropdown-search input {
  background-color: var(--main-bg-color);
  border: none;
  color: var(--main-font-color);
  width: 90%;
}
.dropdown-search input:focus {
  outline-width: 0;
}

/* Change color of dropdown links on hover */
.optionNormal:hover {
  background-color: rgb(71, 75, 83);/* #41b883; */
}

.optionSelected {
  color: var(--header-font-color);
  background-color: var(--button-color)
}
.optionSelected:hover {
  background-color: var(--hover-color)
}

</style>
